module.exports = __webpack_public_path__ + "static/media/zapier.65b02fb3.svg";